import { render, staticRenderFns } from "./test-portal-visualization.vue?vue&type=template&id=5afed46a&"
import script from "./test-portal-visualization.vue?vue&type=script&lang=js&"
export * from "./test-portal-visualization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "test-portal-visualization.vue"
export default component.exports